import React from "react";
import * as util from "../../util";

import Chart from "./charts/chart.jsx";

import connectToStores from "alt-utils/lib/connectToStores";
import AnalyticsStore from "../../stores/AnalyticsStore";
import AnalyticsActions from "../../actions/AnalyticsActions";
import EventStore from "../../stores/EventStore";

class EventTicketSalesChart extends React.Component {
  static getStores() {
    return [AnalyticsStore];
  }

  static getPropsFromStores() {
    return {
      getEventTicketSalesById: AnalyticsStore.getEventTicketSalesById
    };
  }

  componentDidMount() {
    AnalyticsActions.fetchEventTicketSales.defer(this.props.event);
  }

  render() {
    let sales = this.props.getEventTicketSalesById(this.props.event);

    if (sales && sales.length === 0) {
      return (
        <Chart
          height={200}
          placeholder={`Sales data will be available as soon as the first ${
            EventStore.getEventById(this.props.event).name
          } ticket is sold!`}
        />
      );
    }

    let rows = (sales || []).map(function (next) {
      const date = new Date(next.date.year, next.date.month - 1, next.date.day);
      return {
        timeframe: { end: date },
        value: [{ label: "Tickets sold", result: next.count }]
      };
    });

    let filledRows = util.fillMissingDaysNew(rows, "timeframe.end", {
      default: 0
    });
    filledRows = filledRows.map(r => {
      r.timeframe.end = r.timeframe.end.toISOString();
      return r;
    });

    // Only render 180 days worth of sales max, to avoid freezing up browser
    const totalRows = filledRows.length;
    if (totalRows > 180) {
      filledRows = filledRows.slice(filledRows.length - 180);
    }

    const chartOptions = {
      point: { show: false }
    };

    let dataTable = filledRows;

    return (
      <div style={this.props.style}>
        <Chart
          title="Ticket sales"
          type="area"
          indexBy="timeframe.end"
          dateFormat="%b %e"
          height={200}
          chartOptions={chartOptions}
          data={dataTable.length && { result: dataTable }}
        />
      </div>
    );
  }
}

export default connectToStores(EventTicketSalesChart);



// WEBPACK FOOTER //
// ./src/app/components/partials/event-ticket-sales-chart.jsx